<template>
  <div class="container-fluid cards-pf full-height">
    <div v-if="$apollo.loading">
      <div style="margin-top: 10%;" class="text-center">
        <div class="spinner" />
        <strong>กำลังโหลด..</strong>
      </div>
    </div>
    <div v-else>
      <div class="row row-cards-pf">
        <div class="col-xs-12">
          <div class="card-pf">
            <div class="card-pf-heading">
              <h2 class="card-pf-title">แก้ไขร่างแบบขออนุมัติงบประมาณและจัดโครงการ</h2>
            </div>
            <div class="card-pf-body">
              <form action="/" class="form-horizontal">
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">1. ชื่อโครงการ</label>
                  <div class="col-sm-8">
                    <input v-model="projectProposal.name" type="text" class="form-control">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">2. หน่วยงานที่รับผิดชอบ</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" :value="projectProposal.group.name" disabled>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">3. ผู้รับผิดชอบโครงการ</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-sm-5">
                        <input v-model="projectProposal.responsiblePerson.name" type="text" class="form-control">
                      </div>
                      <div class="col-sm-2 text-right">
                        <label class="text-left control-label required-field">โทร.</label>
                      </div>
                      <div class="col-sm-5">
                        <input v-model="projectProposal.responsiblePerson.tel" type="text" class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">4. อาจารย์ที่ปรึกษา</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-sm-5">
                        <input v-model="projectProposal.advisor.name" type="text" class="form-control">
                      </div>
                      <div class="col-sm-2 text-right">
                        <label class="text-left control-label required-field">โทร.</label>
                      </div>
                      <div class="col-sm-5">
                        <input v-model="projectProposal.advisor.tel" type="text" class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">5. ประเภทกิจกรรม</label>
                  <div class="col-sm-8">
                    <div class="radio">
                      <label>
                        <input v-model="projectProposal.type" type="radio" name="type" value="ด้านวิชาการ" required="">
                        ด้านวิชาการ
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input v-model="projectProposal.type" type="radio" name="type" value="ด้านกีฬาและนันทนาการ" required="">
                        ด้านกีฬาและนันทนาการ
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input v-model="projectProposal.type" type="radio" name="type" value="ด้านคุณธรรมจริยธรรม" required="">
                        ด้านคุณธรรมจริยธรรม
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input v-model="projectProposal.type" type="radio" name="type" value="ด้านส่งเสริมศิลปวัฒนธรรม" required="">
                        ด้านส่งเสริมศิลปวัฒนธรรม
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input v-model="projectProposal.type" type="radio" name="type" value="ด้านบำเพ็ญประโยชน์ และรักษาสิ่งแวดล้อม" required="">
                        ด้านบำเพ็ญประโยชน์ และรักษาสิ่งแวดล้อม
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group-title">6. ลักษณะกิจกรรมที่บ่งชี้ถึงอัตลักษณ์สถาบัน</div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field left-padded">ซื่อสัตย์</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.typeCharacteristics[0]" rows="3" class="form-control" />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field left-padded">ใฝ่รู้</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.typeCharacteristics[1]" rows="3" class="form-control" />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field left-padded">สู้งาน</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.typeCharacteristics[2]" rows="3" class="form-control" />
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">7. หลักการและเหตุผล</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.background" rows="5" class="form-control" />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">8. จุดมุ่งหมาย/วัตถุประสงค์</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.objectives" rows="5" class="form-control" />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">9. ลักษณะการดำเนินงาน ปฏิบัติงาน และเป้าหมาย</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.aspectAndGoal" rows="5" class="form-control" />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">10. สถานที่จัดโครงการ</label>
                  <div class="col-sm-8">
                    <input v-model="projectProposal.venue" type="text" class="form-control">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">11. วันที่ดำเนินโครงการ</label>
                  <div class="col-sm-8">
                    <input v-model="projectProposal.heldOn" type="text" class="form-control">
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-sm-3 text-left control-label">12. ผู้เข้าร่วมโครงการ</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-xs-4">
                        <div>
                          <div class="input-group">
                            <span class="input-group-addon">อาจารย์</span>
                            <input v-model="projectProposal.attendee.instructor" type="number" value="0" min="0" class="form-control">
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-4">
                        <div>
                          <div class="input-group">
                            <span class="input-group-addon">นักศึกษา</span>
                            <input v-model="projectProposal.attendee.student" type="number" value="0" min="0" required="required" class="form-control">
                          </div>
                        </div>
                      </div> <div class="col-xs-4">
                        <div>
                          <div class="input-group">
                            <span class="input-group-addon">ประชาชนกลุ่มเป้าหมาย</span>
                            <input v-model="projectProposal.attendee.individual" type="number" value="0" min="0" required="required" class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">13. ขั้นตอนการดำเนินงาน</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.procedures" rows="5" class="form-control" />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">14. ผลที่คาดว่าจะได้รับ</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.expectedOutcome" rows="5" class="form-control" />
                  </div>
                </div>
                <div class="form-group-title">15. งบประมาณการดำเนินงาน</div>
                <div class="row form-group">
                  <label class="col-sm-3 text-left control-label left-padded">เงินสนับสนุนกิจกรรมนักศึกษาจากสถาบันฯ</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-xs-6">
                        <div>
                          <div class="input-group">
                            <span class="input-group-addon">เป็นเงิน</span>
                            <input v-model="projectProposal.budget.osda" type="number" value="0" min="0" class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-sm-3 text-left control-label left-padded">งบอื่นๆ</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-xs-6">
                        <div>
                          <div class="input-group">
                            <span class="input-group-addon">เป็นเงิน</span>
                            <input v-model="projectProposal.budget.other" type="number" value="0" min="0" class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-sm-3 text-left control-label left-padded">งบสนับสนุนจาก บริษัท/ห้าง/ร้าน</label>
                  <div class="col-sm-8">
                    <div class="row">
                      <div class="col-xs-6">
                        <div>
                          <div class="input-group">
                            <span class="input-group-addon">เป็นเงิน</span>
                            <input v-model="projectProposal.budget.sponsors" type="number" value="0" min="0" class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group-title">ประกอบด้วยรายจ่ายดังต่อไปนี้</div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.1 ค่าอาหารนักศึกษา</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.meal" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.2 ค่าที่พัก</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.accommodation" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.3 ค่าวัสดุโครงการ</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.materials" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.4 ค่าวัสดุพาหนะไป-กลับ</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.transportation" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.5 ค่าน้ำมันเชื้อเพลิง</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.gas" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.6 ค่าเช่ารถ</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.vehicleRental" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.7 ค่าผ่านทางพิเศษ</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.tollwayFee" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.8 ค่าเบี้ยเลี้ยงพนักงานขับรถ</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.driver" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.9 ค่าตอบแทนวิทยากร</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.lecture" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label left-padded">15.10 ค่าใช้จ่ายอื่นๆ</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <span class="input-group-addon">เป็นเงิน</span>
                      <input v-model="projectProposal.plannedBudget.other" type="number" value="0" min="0" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 text-left control-label required-field">15.11 วัสดุ/อุปกรณ์/ทรัพยากร ที่ได้รับการสนับสนุนจากหน่วยงานราชการ/เอกชน (ระบุ)</label>
                  <div class="col-sm-8">
                    <textarea v-model="projectProposal.sponsoredMaterials" rows="5" class="form-control" />
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-8 col-sm-offset-3">
                    <button class="btn btn-primary" @click.prevent="submit">บันทึก</button>
                    <router-link :to="{ name: 'projects.show' }" class="btn btn-default">ยกเลิก</router-link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    projectProposal: {
      query: gql`query projectProposal($id: ID!){
      projectProposal(_id: $id) {
        name
        type
        group {
          name
        }
        typeCharacteristics
        venue
        attendee {
          instructor
          student
          individual
          others
        }
        advisor {
          name
          tel
        }
        heldOn
        aspectAndGoal
        objectives
        background
        responsiblePerson {
          name
          tel
        }
        budget {
          osda
          other
          sponsors
        }
        procedures
        expectedOutcome
        plannedBudget {
          meal
          accommodation
          materials
          transportation
          gas
          vehicleRental
          tollwayFee
          driver
          lecture
          other
        }
        sponsoredMaterials
      }
    }`,
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {
      projectProposal: {
        name: '',
        type: '',
        group: {
          name: ''
        },
        typeCharacteristics: [],
        venue: '',
        attendee: {
          instructor: '',
          student: '',
          individual: '',
          others: ''
        },
        advisor: {
          name: '',
          tel: ''
        },
        heldOn: '',
        aspectAndGoal: '',
        objectives: '',
        background: '',
        responsiblePerson: {
          name: '',
          tel: ''
        },
        budget: {
          osda: '',
          other: '',
          sponsors: ''
        },
        procedures: '',
        expectedOutcome: '',
        plannedBudget: {
          meal: '',
          accommodation: '',
          materials: '',
          transportation: '',
          gas: '',
          vehicleRental: '',
          tollwayFee: '',
          driver: '',
          lecture: '',
          other: ''
        },
        sponsoredMaterials: ''
      }
    }
  },
  methods: {
    async submit () {
      const projectProposal = await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $projectProposal: EditProjectProposalInput!) {
            updateProjectProposal(_id: $id, proposal: $projectProposal) {
              _id
            }
          }`,
        variables: {
          projectProposal: {
            name: this.projectProposal.name,
            type: this.projectProposal.type,
            typeCharacteristics: this.projectProposal.typeCharacteristics,
            responsiblePerson: {
              name: this.projectProposal.responsiblePerson.name,
              tel: this.projectProposal.responsiblePerson.tel
            },
            advisor: {
              name: this.projectProposal.advisor.name,
              tel: this.projectProposal.advisor.tel
            },
            background: this.projectProposal.background,
            objectives: this.projectProposal.objectives,
            aspectAndGoal: this.projectProposal.aspectAndGoal,
            venue: this.projectProposal.venue,
            heldOn: this.projectProposal.heldOn,
            attendee: {
              instructor: parseInt(this.projectProposal.attendee.instructor),
              student: parseInt(this.projectProposal.attendee.student),
              individual: parseInt(this.projectProposal.attendee.individual),
              others: parseInt(this.projectProposal.attendee.others)
            },
            procedures: this.projectProposal.procedures,
            expectedOutcome: this.projectProposal.expectedOutcome,
            budget: {
              osda: parseFloat(this.projectProposal.budget.osda),
              other: parseFloat(this.projectProposal.budget.other),
              sponsors: parseFloat(this.projectProposal.budget.sponsors)
            },
            plannedBudget: {
              meal: parseFloat(this.projectProposal.plannedBudget.meal),
              accommodation: parseFloat(this.projectProposal.plannedBudget.accommodation),
              materials: parseFloat(this.projectProposal.plannedBudget.materials),
              transportation: parseFloat(this.projectProposal.plannedBudget.transportation),
              gas: parseFloat(this.projectProposal.plannedBudget.gas),
              vehicleRental: parseFloat(this.projectProposal.plannedBudget.vehicleRental),
              tollwayFee: parseFloat(this.projectProposal.plannedBudget.tollwayFee),
              driver: parseFloat(this.projectProposal.plannedBudget.driver),
              lecture: parseFloat(this.projectProposal.plannedBudget.lecture),
              other: parseFloat(this.projectProposal.plannedBudget.other)
            },
            sponsoredMaterials: this.projectProposal.sponsoredMaterials
          },
          id: this.$route.params.id
        }
      })

      // TODO: Implement toast notification

      this.$router.push({ name: 'projects.show', params: { id: projectProposal.data.updateProjectProposal._id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/views/projects/Edit.vue